import { Address } from "@data/schema/loan-appication/address";
import { DetailsOfTransaction } from "@data/schema/loan-appication/details-of-transaction";
import { OtherFinance } from "@data/schema/loan-appication/other-finance";

export class LoanInfo {
  sLoanPurpose: string;
  sOccupancy: string;
  sAppraisalValue: number;
  sPurchasePrice: number;
  sDownpaymentPercent: number;
  sDownpaymentAmount: number;
  sDownpaymentSource: string;
  sLoanAmount: number;
  sUnits: number;
  sSubjectAddress: Address = new Address();
  sAUSType: string;

  sPMI: number;
  sLenderPayMIFlag: boolean;
  sAmountPaidInCash: number;
  sPMIFinanced: number;
  sLoanAmountWithPMIFinanced: number;
  sAnnualMIRate: number;

  sMiddleCreditScore: number;
  sLoanType: string;
  sProgram: string;
  sNoteRate: number;
  sEscrowWaiverFlag: boolean;
  sLTV: number;
  sCLTV: number;
  sHCLTV: number;
  sEliigible: boolean;
  sAPR: number;
  sDTI: number;
  sExpense: number;
  sIncome: number;
  sLockStatus: string;
  sLockDate: string;
  sLockExpired: string;
  sCompensation: string;
  sRequestddRate: number;
  sTotalLockPrice: number;

  sPropertyType : string;
  sAmountExistingLien : number;
  sOriginalCost : number;
  sYearAcquired : number;
  sYearBuilt : number;
  sLegalDescription : string;


  // proposed housing expenses
  sFirstMortgage: number;
  sOtherFinances: number;
  sHazardInsurance: number;
  sPropertyTax: number;
  sMortgageInsurance: number;
  sHOA: number;
  sOther: number;
  sTotalAmount: number;

  // details of transaction
  sDetailsOfTrans: DetailsOfTransaction = new DetailsOfTransaction();
  // other Finaces
  sOtherFinance: OtherFinance = new OtherFinance();

  sBranch: string;
  sLoanStatus: string;
}
